import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DialogService } from '@app/services/dialog.service';

const dummyImages = [
  {
    id: 1,
    src: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=400&h=300&fit=crop'
  },
  {
    id: 2,
    src: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=400&h=300&fit=crop'
  },
  {
    id: 3,
    src: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=400&h=300&fit=crop'
  },
  {
    id: 4,
    src: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=400&h=300&fit=crop'
  }
];

@Component({
  selector: 'app-record-create-form',
  templateUrl: './record-create-form.component.html',
})
export class RecordCreateFormComponent implements OnInit {

  @Input() form!: FormGroup;
  images = dummyImages;


  get isDirty(): boolean {
    return this.form?.dirty || false;
  }


  get imageControl() {
    return this.form?.get('images') as FormControl;
  }

  constructor(protected fb: FormBuilder, protected dialogModalService: DialogService) { }

  ngOnInit(): void {}

  selectImg(id: number) {
    const _selectImgs = this.imageControl.value as number[] || [];
    const index = _selectImgs.findIndex(i => i === id);
    if (index > -1) {
      _selectImgs.splice(index, 1);
      if (_selectImgs.length === 0) {
        this.imageControl.markAsPristine();
      }
    } else {
      _selectImgs.push(id);
      this.imageControl.setValue(_selectImgs);
      this.imageControl.markAsDirty();
    }

  }

}
